export default () => {
  const videos = document.querySelectorAll("video");
  let loaded = false;

  if (window.innerWidth < 900) {
    return;
  }

  if (navigator.connection && navigator.connection.type == "cellular") {
    return;
  }

  window.addEventListener("load", () => {
    loadVideos();
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 900) {
      loadVideos();
    }
  });

  function loadVideos() {
    if (loaded) {
      return;
    }
    loaded = true;

    videos.forEach((vd) => {
      const sources = vd.querySelectorAll("source");

      sources.forEach((sr) => {
        if (sr.dataset.src) {
          sr.setAttribute("src", sr.dataset.src);
        }
      });

      const thumbnail = vd.parentElement.querySelector("img");
      thumbnail.style.opacity = 0;

      vd.load();
    });
  }
}
